import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { LFTooltip, HtmlTooltip } from './../Tooltips';
/**
 * Author: NRK.
 */

const ColuumnSumUp = ({
  permissionGroupFilterName = null,
  countComment,
  latestCommentDate = null,
  isIssueStatusClosed,
}) => {
  return (
    <div>
     
      <Typography variant="subtitle2" component="div" color="textSecondary" >
        {/* Flexbox style */}
        <Box
          display="flex"
          flexWrap="wrap"
          bgcolor="background.paper"
          css={{ maxWidth: '100%' }}
        >
          <Box pt={0.5} pr={1}>
            {isIssueStatusClosed && 'ปิด (Closed)'}
          </Box>
          
          {permissionGroupFilterName && (
            <Box pt={0.5} pr={1}>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography>
                      <Box fontSize={14}>
                      มีการส่งต่อเรื่องแบบระบุกลุ่มผู้ดูแล-ดำเนินการ มายังกลุ่ม  <span style={{color: 'blue'}}>{permissionGroupFilterName}</span> ที่ท่านเป็นสมาชิก
                      </Box>
                    </Typography>
                  </React.Fragment>
                }
              >
                <PeopleAltOutlinedIcon
                  fontSize="small"
                  style={{ verticalAlign: 'middle' }}
                  color="primary"
                />
              </HtmlTooltip>
            </Box>
          )}
          <Box pt={0.5} pr={1}>
            <LFTooltip title={`แสดงความคิดเห็น ${countComment} รายการ`}>
              <div>
                <CommentOutlinedIcon
                  fontSize="small"
                  style={{ verticalAlign: 'middle' }}
                />{' '}
                {countComment}{' '}
              </div>
            </LFTooltip>
          </Box>
          <Box pt={0.5} pr={1} fontSize={12}>
            {countComment > 0 && `ล่าสุด ${latestCommentDate}`}
          </Box>
        </Box>
      </Typography>
    </div>
  );
};

// propTypes
ColuumnSumUp.propTypes = {
  permissionGroupFilterName: PropTypes.string,
  countComment: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  latestCommentDate: PropTypes.string,
  isIssueStatusClosed: PropTypes.bool.isRequired,
};

/**
 * By default it will only shallowly compare complex objects in the props object.
 * If you want control over the comparison,
 * you can also provide a custom comparison function as the second argument.
 * https://reactjs.org/docs/react-api.html
 * https://stackoverflow.com/questions/63502588/avoid-rerendering-child-when-passing-object-in-props
 */
export default React.memo(ColuumnSumUp);
